<template>
  <div style="float: right; text-align: right">
    <div v-if="file.department">
      <template v-if="file.department.id == 7">
        <strong>
          <span class="department7 uppercase">{{ file.department.name }}</span>
        </strong>
        <a @click="updateDepartment(1)" class="department1">
          Legal
          <v-icon>chevron_right</v-icon>
        </a>
      </template>
      <template v-if="file.department.id == 1">
        <a @click="updateDepartment(7)" class="department7">
          <v-icon>chevron_left</v-icon>Welcome
        </a>
        <strong>
          <span class="department1 uppercase">{{ file.department.name }}</span>
        </strong>
        <a @click="updateDepartment(2)" class="department2">
          Post completion
          <v-icon>chevron_right</v-icon>
        </a>
      </template>
      <template v-if="file.department.id == 2">
        <a @click="updateDepartment(1)" class="department1">
          <v-icon>chevron_left</v-icon>Legal
        </a>
        <strong>
          <span class="department2 uppercase">{{ file.department.name }}</span>
        </strong>
        <a @click="$emit('open-boxes')" class="department3">
          Dead
          <v-icon>chevron_right</v-icon>
        </a>
      </template>
      <template v-if="file.department.id == 3">
        <a @click="removeBox" class="department2">
          <v-icon>chevron_left</v-icon>Post completion
        </a>
        <strong>
          <span class="department3 uppercase">{{ file.department.name }}</span>
        </strong>
      </template>
    </div>
    <v-menu offset-y v-if="file.category">
      <template v-slot:activator="{ on }">
        <v-btn color="info" dark v-on="on" small>
          {{ file.category.name }}<v-icon>expand_more</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          :to="{ name: 'taskAdd', query: { fileid: $route.params.id } }"
        >
          <v-list-tile-title>Add task</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-if="$keycloak.hasRealmRole('salesadmin')"
          @click="toggleSwiftMove"
        >
          <v-list-tile-title>Toggle swift move</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="!logShow" @click="$emit('open-logs')">
          <v-list-tile-title>Show logs</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="$keycloak.hasRealmRole('root')" @click="deleteFile">
          <v-list-tile-title>Delete file</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-if="$keycloak.hasRealmRole('root')"
          @click="testMortgageOfferExpires"
        >
          <v-list-tile-title>Test mortgage offer expires</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <div v-if="file.swiftMove"><v-icon>verified</v-icon>Swift move</div>
    <div>
      <v-btn
        :to="{ name: 'paymentFile', params: { id: $route.params.id } }"
        small
      >
        <v-icon>credit_card</v-icon>Payments
      </v-btn>
    </div>
    <div v-if="colpsFile && colpsFile.length > 0">
      Colp:
      <router-link
        v-for="colp in colpsFile"
        :key="colp.id"
        :to="{ name: 'colp', params: { id: colp.id } }"
      >
        <v-chip color="red" text-color="white">{{ colp.id }}</v-chip>
      </router-link>
    </div>
    <v-btn
      :to="{
        name: 'ledger',
        params: { office: ledger.office, id: ledger.id }
      }"
      v-if="ledger"
      ><v-icon>account_balance</v-icon>Ledger</v-btn
    >
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import ca from "@/api/ca";
export default {
  name: "HeaderRight",
  props: ["file", "logShow"],
  data() {
    return { colpsFile: null, ledger: null };
  },
  methods: {
    async updateDepartment(departmentId) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/department/${departmentId}`,
        null
      );
      this.$emit("update");
    },
    toggleSwiftMove() {
      this.file.swiftMove
        ? this.updateSwiftMove(false)
        : this.updateSwiftMove(true);
    },
    async updateSwiftMove(swiftMove) {
      await nbmlaw.put(
        `/cors/admin/file/files/${this.$route.params.id}/swiftMove`,
        { swiftMove }
      );
      this.$emit("update");
    },
    async deleteFile() {
      if (confirm(`WARNING: this will delete the file.  Are you sure?`)) {
        await nbmlaw.delete(`/cors/admin/file/files/${this.$route.params.id}`);
        this.$emit("update");
      }
    },
    async removeBox() {
      if (
        confirm(
          `WARNING: this will remove the file from box ${this.file.box.id}.  Are you sure?`
        )
      ) {
        await nbmlaw.delete(
          `/cors/admin/file/files/${this.$route.params.id}/box`
        );
        this.$emit("update");
      }
    },
    async fetchColpsFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/colps`
      );
      this.colpsFile = response.data;
    },
    async fetchLedger() {
      const [q1, q5] = await Promise.all([
        this.fetchLedgers("q1"),
        this.fetchLedgers("q5")
      ]);
      if (q1.length === 1) {
        this.ledger = {
          office: "q1",
          id: q1[0].id
        };
      }
      if (q5.length === 1) {
        this.ledger = {
          office: "q5",
          id: q5[0].id
        };
      }
    },
    async fetchLedgers(office) {
      let response = await ca.get(`/${office}/matters`, {
        params: {
          reference: this.$route.params.id
        }
      });
      return response.data;
    },
    async testMortgageOfferExpires() {
      await nbmlaw.put(`/cors/admin/file/files/mortgageofferexpires`, null);
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchColpsFile();
        this.fetchLedger();
      }
    }
  }
};
</script>
